import variables from './variables';

export { variables };


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-style-const/es/index.js
// module id = 320
// module chunks = 0